import { isEqualAsNumber } from '@/helpers/math';

// Validate whether the input is a valid number parameter:
// (1) - Is non empty
// (2) - Contains only numbers
export const isValidNumberParam = (val = '') => !!val && RegExp('^\\d+$').test(val);

export const isValidNumberOrZeroParam = (val = '') => !!val || isEqualAsNumber(0, val);

// Validate whether a slug is valid:
// (1) - Is non empty
// (2) - Does not start or end with a hyphen
// (3) - Only contains letters and hyphens
// (4) - All sections between hyphens are non empty
export const isValidSlugParam = (slug = '') => (
  !!slug
    && !(slug[0] === '-')
    && !(slug[slug.length - 1] === '-')
    && RegExp('^[\\d\\w-]+$').test(slug)
    && !slug.split('-').filter((v) => !v).length
);

// Validate whether a search term is valid:
// (1) - Is non empty
export const isValidSearchParam = (term) => (
  !!term
);